import { Container } from './CardContainer.styled'

export type CardContainerProps = {
  boxShadow?: boolean
}

const CardContainer: React.FC<CardContainerProps> = ({ children, boxShadow }) => {
  return (
    <Container boxShadow={boxShadow} data-test='CardContainer'>
      {children}
    </Container>
  )
}

export default CardContainer
